import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c11c072"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("...")
const _hoisted_2 = {
  key: 0,
  class: "spin"
}
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_badge = _resolveComponent("ion-badge")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list_header = _resolveComponent("ion-list-header")!
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_payment_info = _resolveComponent("payment-info")!
  const _component_slides = _resolveComponent("slides")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, { fixed: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  ($setup.loading)
                    ? (_openBlock(), _createBlock(_component_ion_title, { key: 0 }, {
                        default: _withCtx(() => [
                          _hoisted_1
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_ion_title, { key: 1 }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.t('OrderPage.order')) + " #" + _toDisplayString($setup.order.code), 1)
                        ]),
                        _: 1
                      })),
                  _createVNode(_component_ion_buttons, { slot: "start" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        slot: "icon-only",
                        "router-link": "/orders"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, { icon: $setup.arrowBackOutline }, null, 8, ["icon"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          ($setup.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_ion_spinner)
              ]))
            : (_openBlock(), _createBlock(_component_ion_grid, {
                key: 1,
                fixed: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_list, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString($setup.t('OrderPage.orderStatus')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_badge, {
                            color: $setup.getOrderStatusColor($setup.order.status)
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString($setup.order.status), 1)
                            ]),
                            _: 1
                          }, 8, ["color"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_list_header, { color: "primary" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.t('OrderPage.orderItems')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.openBreakdownPriceModal())),
                        button: "",
                        detail: ""
                      }, {
                        default: _withCtx(() => [
                          ($setup.order.designPhoto)
                            ? (_openBlock(), _createBlock(_component_ion_thumbnail, {
                                key: 0,
                                slot: "start"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("img", {
                                    src: $setup.order.designPhoto
                                  }, null, 8, _hoisted_3)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                            default: _withCtx(() => [
                              _createElementVNode("h3", null, _toDisplayString($setup.order.productName), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createElementVNode("b", null, _toDisplayString($setup.t('OrderPage.orderTotal')) + "HK$ " + _toDisplayString(Number($setup.order.totalPrice).toLocaleString()), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _withDirectives(_createVNode(_component_payment_info, null, null, 512), [
                    [_vShow, $setup.order.status == '待付款' || $setup.order.paymentMethod == 'bank']
                  ]),
                  _withDirectives(_createVNode(_component_ion_list, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_list_header, { color: "primary" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.t('OrderPage.petPhotos')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_slides, {
                        photoLinks: $setup.order.photoLinks,
                        hidePagination: true
                      }, null, 8, ["photoLinks"])
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, $setup.order.photoLinks && $setup.order.photoLinks.length > 0]
                  ]),
                  _withDirectives(_createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                        default: _withCtx(() => [
                          _createTextVNode("寵物特徵描述：" + _toDisplayString($setup.order['寵物1特徵備註']), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, $setup.order['寵物1特徵備註']]
                  ]),
                  _createVNode(_component_ion_list, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_list_header, { color: "primary" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.t('OrderPage.deliveryInfo')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString($setup.t('CheckoutPage.estimatedDeliveryDate')) + _toDisplayString($setup.formatDateString($setup.order.deliveryDate)), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString($setup.t('deliveryMethod')) + " " + _toDisplayString($setup.order.deliveryMethod), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString($setup.t('deliveryAddress')) + _toDisplayString($setup.order.deliveryAddress), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString($setup.t('customerName')) + _toDisplayString($setup.order.customerName), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString($setup.t('contactPhone')) + _toDisplayString($setup.order.contactPhone), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString($setup.t('customerEmail')) + _toDisplayString($setup.order.customerEmail), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}